import React from "react";
import Layout from "../../Components/Dashboard/Layout/Layout";
import AddServicesSection1 from "../../Components/Dashboard/AddServices/AddServicesSection1";

const AddServices = () => {
  return (
    <>
      <Layout>
        <div
          className="dashboard__content hover-bgc-color"
          style={{ marginTop: "6%" }}
        >
          <AddServicesSection1 />
        </div>
      </Layout>
    </>
  );
};

export default AddServices;
